import { Injectable } from '@angular/core';
import { ListBaseService } from './base/list-base.service';

@Injectable({
    providedIn: 'root',
})
export class ListService extends ListBaseService {
    constructor() {
        super();
    }
}
